import { StyleSheet, View, ViewProps } from 'react-native';

import { spacing } from '@pletly/ui';

export const EmptyContentContainer = ({ children, style, ...props }: ViewProps) => {
	return (
		<View {...props} style={[styles.emptyContainer, style]}>
			{children}
		</View>
	);
};

const styles = StyleSheet.create({
	emptyContainer: {
		padding: spacing(4),
		alignItems: 'center',
	},
});
